import ApiUrl from "../../configTools/apiUrl";
const User = JSON.parse(localStorage.getItem("user-info"));
const Get = (asignValues)=>{
    fetch(ApiUrl.API_URL_Orders,{
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        }
    })
    .then(res=>res.json())
    .then(data =>{
        if(data.success){
            asignValues(data.responce);
        }
    });
}

export default Get